import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/basic-health/lab-procedures/fvs";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	fvs: {
		id: "form.fvs",
		defaultMessage: "Fehérvérsejt szám"
	},
	value: {
		id: "form.fvs.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "bh_fvs",
	value: {
		schemaId: "fvs",
		title: messages.fvs,
		validator,
		fieldset,
		isImportant: true
	}
};
